import Alpine from 'alpinejs'
import Splide from '@splidejs/splide'
import focus from '@alpinejs/focus'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'

// Components
Alpine.plugin(focus)

// Global
window.Alpine = Alpine
window.Splide = Splide
window.AutoScroll = AutoScroll

// Inits
Alpine.start()
